// Auth0 user-migration phase recorded on an organisation (`auth0_migration_version`,
// returned in the org GET response). v2 = user migration complete: users are then
// managed in Auth0, so legacy user management must be turned off for that org.
export const AUTH0_MIGRATION_VERSION = {
  V0: "v0",
  V1: "v1",
  V2: "v2",
} as const;

// True only when the org has fully migrated its users to Auth0 (v2). Any other
// value — including not-set (undefined/null) and v0/v1 — keeps the current legacy
// behaviour, so callers can pass a possibly-absent field straight through.
export const isAuth0UserMigrationComplete = (
  version?: string | null,
): boolean => version === AUTH0_MIGRATION_VERSION.V2;
